import React, { createContext } from 'react'

type ToastContextProps = {
	addToast: (type: 'success' | 'error' | 'warning' | 'info', message: string, rawMessage?: string | React.ReactNode) => void
}

const context: ToastContextProps = {
	addToast: () => {
	}
}

export const ToastContext = createContext(context)